/** @jsx jsx */
import { jsx } from 'theme-ui';

const NotFound = () => {
  return <h1 sx={{ fontFamily: 'body' }}>Not found</h1>;
};

export default NotFound;
